enum JobStage {
	Undefined = -1,
	Pending = 0,
	Shortlisted = 5,
	Interested = 18,
	InterviewOne = 40,
	InterviewTwoPlus = 50,
	Offered = 80,
	Placed = 90,
}

export default JobStage;